import Link from "next/link";
import {getCreatorRoute, SITE_URL} from "common/const";
import styles from "components/cards/search/SellerShopSearchItemCard.module.scss";
import classNames from "classnames";
import Image from "next/image";
import utilStyles from "styles/utils.module.scss";
import ArrowRightIcon from "images/icons/arrow_right_black.svg";
import DefaultProfileIcon from "images/icons/default_profile.svg";
import SimplePostListCard from "components/cards/SimplePostListCard";
import TruncateMarkup from "react-truncate-markup";
import CreatorBadgeIcon from "images/icons/creator_badge.svg";
import {highlightMatchedText} from "common/utils";
import parse from "html-react-parser";


const SellerShopSearchItemCard = (props) => {
    const {sellerShop, showPosts, onItemClick, highlightKeyword} = props;

    const creatorDetail = sellerShop.seller_profile;
    const name = creatorDetail.nickname;
    const profileImage = creatorDetail.profile_image_url;
    const introduction = parse(creatorDetail.introduction ? highlightMatchedText(creatorDetail.introduction, highlightKeyword) : '');

    const posts = sellerShop.posts;

    const onPostClick = (post, index) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'SellerShopSearchItemCardPostClick', {
                creatorNickname: name,
                postId: post.id,
                itemIndex: index,
            }
        );
    };

    return (
        <div className={classNames(styles.container, !showPosts && styles.largeCardContainer)}>
            <Link
                href={getCreatorRoute(creatorDetail.code)}>
                <a className={styles.brandCreatorCardContainer} onClick={onItemClick}>
                    {
                        profileImage ?
                            <div className={classNames(styles.brandCreatorProfileImage, !showPosts && styles.largeProfileImage)}>
                                <Image unoptimized src={profileImage} layout="fill" objectFit="cover"/>
                            </div>
                            :
                            <DefaultProfileIcon
                                className={classNames(styles.brandCreatorProfileImage, !showPosts && styles.largeProfileImage)}
                                viewBox="0 0 32 32"
                            />
                    }
                    <div className={utilStyles.fullFlex}>
                        <span className={classNames(styles.brandCreatorCardTitle, !showPosts && styles.largeProfileTitle)}>
                            {
                                name.split(/(_+)/).map((e, idx) => {
                                    if (e.includes('_')) {
                                        return <span style={{
                                            fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu,\n' +
                                                '  Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
                                        }} key={idx}>{e}</span>
                                    } else {
                                        return e;
                                    }
                                })
                            }
                            {
                                creatorDetail.is_verified &&
                                <CreatorBadgeIcon viewBox="0 0 16 16" className={classNames(utilStyles.verticalMiddle, styles.badge)} />
                            }
                        </span>
                        {
                            introduction && introduction.length > 0 &&
                            <div className={classNames(styles.cardDescriptionWrapper, !showPosts && styles.largeProfileDescriptionWrapper)}>
                                <TruncateMarkup lines={1} ellipsis={<span>...</span>}>
                                <span className={classNames(styles.brandCreatorCardDescription, !showPosts && styles.largeProfileDescription)}>
                                    {introduction}
                                </span>
                                </TruncateMarkup>
                            </div>
                        }
                    </div>
                    {
                        !showPosts &&
                        <div className={styles.arrowIcon}>
                            <ArrowRightIcon viewBox="0 0 12 12" width={20} height={20}/>
                        </div>
                    }
                </a>
            </Link>
            {
                showPosts && posts.length > 0 &&
                <div className={styles.postListContainer}>
                    {
                        [...Array(4).keys()].map((index) => {
                            const post = posts[index];
                            return (
                                <div className={styles.postContainer}>
                                    {
                                        post ?
                                            <SimplePostListCard
                                                post={post}
                                                hideTextAndProduct
                                                noBorderRadius
                                                miniIcon
                                                onPostClick={() => onPostClick(post, index)}
                                                hideScrapButton
                                            />
                                            :
                                            <div className={styles.postPlaceholder} />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
};

export default SellerShopSearchItemCard;
